import React from 'react';
import styled from 'styled-components';


const StyledBack = styled.button`
  position: absolute;
  width: 28px;
  height: 28px;
  padding: 6px;
  top: 24px;
  left: 2%;
  border: none;
  background-color: transparent;
  z-index: 100;
  cursor: pointer;
  
  @media screen and (min-width: 767px) {
    top: 10vh;
    left: 10vw;
  }
  
  svg {
    width: 100%;
    vertical-align: middle;
  }
  
  &:focus {
     outline: none;
  }
`;

const BackButton = ({theme, analyticsEvent, id}) => {

    const onClick = () => {
      analyticsEvent && analyticsEvent();
    };

      return (
          <StyledBack {...{onClick}} id={id}>
              <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M7 14C6.708 14 6.418 13.873 6.22 13.627L0.22066 7.62698C-0.07734 7.25598 -0.07334 6.72598 0.23166 6.35998L6.23166 0.359984C6.58466 -0.0640163 7.21566 -0.121016 7.64066 0.231984C8.06466 0.584984 8.12166 1.21598 7.76766 1.63998L2.29266 7.01098L7.779 12.373C8.125 12.803 8.057 13.433 7.626 13.779C7.442 13.928 7.22 14 7 14Z" fill={theme}/>
              </svg>
          </StyledBack>
      );
};


export default BackButton;